import { render, staticRenderFns } from "./blog-15.vue?vue&type=template&id=04dd055e&scoped=true"
import script from "./blog-15.vue?vue&type=script&lang=js"
export * from "./blog-15.vue?vue&type=script&lang=js"
import style0 from "./blog-15.vue?vue&type=style&index=0&id=04dd055e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd055e",
  null
  
)

export default component.exports